// M17 T2 — set erişim rolü seçicisi (veri sahibi / denetçi). Portal › Kullanıcılar drawer'ı ve
// danışman › Müşteri profili › "KPI erişimi" editörü ortak kullanır; etiketler shared
// `KPI_ACCESS_ROLE_LABELS` tek kaynağından. 200 px; ≤640 px'te satırın altına sarar.

import { KPI_ACCESS_ROLES, KPI_ACCESS_ROLE_LABELS, type KpiAccessRole } from "@mahir/shared";

interface Props {
  value: KpiAccessRole;
  ariaLabel: string;
  disabled: boolean;
  onChange: (role: KpiAccessRole) => void;
}

export function KpiSetRoleSelect({ value, ariaLabel, disabled, onChange }: Props): JSX.Element {
  return (
    <select
      aria-label={ariaLabel}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as KpiAccessRole)}
      className="p-1.5 rounded border text-sm max-sm:basis-full disabled:opacity-50"
      style={{
        width: 200,
        borderColor: "var(--color-border)",
        background: "var(--color-surface)",
        color: "var(--color-text)",
        fontFamily: "var(--font-sans)",
      }}
    >
      {KPI_ACCESS_ROLES.map((r) => (
        <option key={r} value={r}>
          {KPI_ACCESS_ROLE_LABELS[r]}
        </option>
      ))}
    </select>
  );
}
